import { createContext } from "react";

const UserStatus = createContext({});

export default UserStatus;
